import type {DashCardConfig} from '@/config/menuConfig';
import {formatValues} from '@/utils/dashboard';

interface DashCardType extends DashCardConfig {
  value: string | number;
}

const DashboardCard: React.FC<DashCardType> = ({label, value, valueType}) => {
  const formattedValue =
    typeof value === 'number'
      ? formatValues(value, valueType, undefined, true)
      : '-';
  return (
    <div className="flex flex-col bg-white dark:bg-gray-900 p-3 w-48 h-20 gap-2 border border-gray-300 rounded-md cursor-pointer dark:border-dark-borderMid">
      <h3 className="text-sm text-gray-600 dark:text-gray-200">{label}</h3>
      <p className="text-xl text-gray-700 dark:text-gray-100 font-semibold">
        {formattedValue}
      </p>
    </div>
  );
};

export default DashboardCard;
